/* eslint-disable react/no-danger */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';
import SmoothScrollbar from 'smooth-scrollbar';
import OverscrollPlugin from 'smooth-scrollbar/plugins/overscroll';

import theme from 'styles/theme';
import PolicyNotice from 'components/PolicyNotice';
import Header from 'components/Header';
import Footer from 'components/Footer';
import Scrollbar from 'components/Scrollbar';
import appConfig from '../../utils/appConfig';
import 'styles';

SmoothScrollbar.use(OverscrollPlugin);

const Layout = ({
  children,
  path,
  lightTheme,
  background,
  blackMenuButton,
  getScrollPosition,
  renderOutsideScrollContainer,
}) => {
  const [isPolicyShown, setPolicyShown] = useState(false);
  const [scrollPosition, setScrollPosition] = useState(0);

  useEffect(() => {
    if (getScrollPosition) getScrollPosition(scrollPosition);
  }, [scrollPosition]);

  useEffect(() => {
    // if (window.Helpshift) {
    //   if (path === '/careers/') {
    //     window.Helpshift('hide');
    //   } else {
    //     window.Helpshift('show');
    //   }
    // }
    // if (window.atcBotApi) {
    //   if (path === '/careers/') {
    //     window.atcBotApi.showWidgets = true;
    //   } else {
    //     window.atcBotApi.showWidgets = false;
    //   }
    // }

    window.jivo_onLoadCallback = () => {
      if (path === '/careers/') {
        enableJIVOChat();
      }
    }
    // if (appConfig.ConfiguredPaths.includes(path) || appConfig.ConfiguredPaths.includes('/*')) {
    //   const timer = setTimeout(() => {
    //     window.Helpshift('open');
    //   }, appConfig.OpenPopupInSeconds);
    //   return () => clearTimeout(timer);
    // }
  }, []);
  // This effect runs every path change and updates the visibility of the pure chat bot.
  // This hook alone is not enough since window,purechatapi methods are initialized only after the complete
  // script loaded so if the user directly access career page purechatapi's will not have been loaded
  useEffect(() => {
    // if (window.atcBotApi && window.atcBotApi.isLoaded) {
    //   if (path === '/careers/') {
    //     window.atcBotApi.showWidget();
    //     enableJIVOChat();
    //   } else {
    //     window.atcBotApi.hideWidget();
    //     enableJIVOChat('block');
    //   }
    // }
    // if (window.Helpshift) {
    //   if (path === '/careers/') {
    //     window.Helpshift('hide');
    //   } else {
    //     window.Helpshift('show');
    //   }
    // }
  }, [path]);

  const enableJIVOChat = (display = 'none') => {
    const element = document.querySelector('body jdiv>jdiv');
    if (element) {
      element.style.display = display;
    }
  }

  return (
    <>

      {/* Inspectlet Asynchronous Code */}
      <script
        dangerouslySetInnerHTML={{
          __html: `(function() {
          window.__insp = window.__insp || [];
          __insp.push(['wid', 1060140346]);
          var ldinsp = function(){
          if(typeof window.__inspld != "undefined") return; window.__inspld = 1; var insp = document.createElement('script'); insp.type = 'text/javascript'; insp.async = true; insp.id = "inspsync"; insp.src = ('https:' == document.location.protocol ? 'https' : 'http') + '://cdn.inspectlet.com/inspectlet.js?wid=1060140346&r=' + Math.floor(new Date().getTime()/3600000); var x = document.getElementsByTagName('script')[0]; x.parentNode.insertBefore(insp, x); };
          setTimeout(ldinsp, 0);
          })();`,
        }}
      />

      {/* Help shift */}
      {/* <script
        dangerouslySetInnerHTML={{
          __html: `(function () {
          var PLATFORM_ID = "american-technology_platform_20200210210907329-bc68cd7228092ed",
          DOMAIN = "american-technology",
          LANGUAGE = "en";
          window.helpshiftConfig = {
            platformId: PLATFORM_ID,
            domain: DOMAIN,
            language: LANGUAGE
          };
        }) ();
        !function(t,e){if("function"!=typeof window.Helpshift){var n=function(){n.q.push(arguments)};n.q=[],window.Helpshift=n;var i,a=t.getElementsByTagName("script")[0];if(t.getElementById(e))return;i=t.createElement("script"),i.async=!0,i.id=e,i.src="https://webchat.helpshift.com/webChat.js";var o=function(){window.Helpshift("init")};window.attachEvent?i.attachEvent("onload",o):i.addEventListener("load",o,!1),a.parentNode.insertBefore(i,a)}else window.Helpshift("update")}(document,"hs-chat");`,
        }}
      ></script> */}

      {/* Jivo chat */}
      <script src="//code.jivosite.com/widget/3oEdoJDqjs" async></script>

      {/* ATC CHAT */}
      {/* <script
        type="text/javascript"
        data-cfasync="false"
        dangerouslySetInnerHTML={{
          __html: `window.atcBotApi = { l: [], t: [], on: function () { this.l.push(arguments); }, showWidgets: true};
          (function () {
            var done = false;
            var script = document.createElement("script");
            script.async = true;
            script.type = "text/javascript";
            script.src = "https://chatbot.american-technology.net/widgets/atcChatWidgets.js";
            document.getElementsByTagName("HEAD").item(0).appendChild(script);
            script.onreadystatechange = script.onload = function (e) {
              if (!done && (!this.readyState || this.readyState == "loaded" || this.readyState == "complete")) {
                window.atcBotApi = new ATCChatWidgetAPi();
                done = true;
              }
            }; })();`,
        }}
      /> */}

      {/* Purechat */}
      {/* <script
        type="text/javascript"
        data-cfasync="false"
        dangerouslySetInnerHTML={{
          __html: `window.purechatApi = { l: [], t: [], on: function () { this.l.push(arguments); } }; (function () { var done = false; var script = document.createElement("script"); script.async = true; script.type = "text/javascript"; script.src = "https://app.purechat.com/VisitorWidget/WidgetScript"; document.getElementsByTagName("HEAD").item(0).appendChild(script); script.onreadystatechange = script.onload = function (e) { if (!done && (!this.readyState || this.readyState == "loaded" || this.readyState == "complete")) { var w = new PCWidget({c: "96aa9e95-4a90-4ef1-a99d-a98ca014a91d", f: true }); done = true; } }; })();`,
        }}
      /> */}

      <ThemeProvider theme={theme}>
        <div
          style={{
            maxWidth: '100vw',
            overflow: 'hidden',
            background:
              background ||
              (lightTheme
                ? '#ffffff'
                : 'linear-gradient(180deg, #0D0D16 0%, #181726 100%), #100f1b'),
          }}
        >
          <PolicyNotice
            lightTheme={lightTheme}
            isPolicyShown={isPolicyShown}
            setPolicyShown={setPolicyShown}
          />
          <Header
            lightTheme={lightTheme}
            path={path}
            blackMenuButton={blackMenuButton}
            isScollTop={scrollPosition < 20}
            style={{ top: isPolicyShown ? 48 : 0 }}
          />
          <Scrollbar
            speed={100}
            damping={0.1}
            thumbMinSize={20}
            renderByPixels
            continuousScrolling
            onScroll={({ offset }) => offset && setScrollPosition(offset.y)}
            style={{ height: isPolicyShown ? 'calc(100vh - 48px)' : '100vh' }}
          >
            <main id="main">{children}</main>
            <Footer />
          </Scrollbar>
          {renderOutsideScrollContainer}
        </div>
      </ThemeProvider>

      {/* HubSpot Embed Code */}
      {/* <script
        type="text/javascript"
        id="hs-script-loader"
        async
        defer
        src="//js.hs-scripts.com/2117583.js"
      ></script> */}
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  path: PropTypes.string.isRequired,
  lightTheme: PropTypes.bool,
  background: PropTypes.string,
  blackMenuButton: PropTypes.bool,
  getScrollPosition: PropTypes.func,
  renderOutsideScrollContainer: PropTypes.node,
};

export default Layout;
